import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, Instagram, Youtube, Linkedin, ArrowUpRight } from 'lucide-react';
import { motion } from 'framer-motion';

const FooterAlt = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black text-white">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-12 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 mb-16">
          {/* Brand + CTA */}
          <div>
            <h2 className="text-6xl lg:text-7xl font-black uppercase mb-6 leading-none">
              LET'S
              <br />
              WORK
            </h2>
            <Link
              to="/contact"
              className="inline-flex items-center text-xl font-bold group"
            >
              <span className="border-b-2 border-white group-hover:border-transparent transition-colors">
                Get in touch
              </span>
              <ArrowUpRight className="ml-2 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" size={24} />
            </Link>
          </div>

          {/* Links Grid */}
          <div className="grid grid-cols-2 gap-8">
            <div>
              <h4 className="text-xs font-bold uppercase tracking-wider mb-6 text-gray-500">Navigate</h4>
              <ul className="space-y-3">
                <li>
                  <Link to="/" className="text-lg font-semibold hover:text-gray-300 transition-colors">
                    Home
                  </Link>
                </li>
                <li>
                  <Link to="/portfolio" className="text-lg font-semibold hover:text-gray-300 transition-colors">
                    Work
                  </Link>
                </li>
                <li>
                  <Link to="/services" className="text-lg font-semibold hover:text-gray-300 transition-colors">
                    Services
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-lg font-semibold hover:text-gray-300 transition-colors">
                    About
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-xs font-bold uppercase tracking-wider mb-6 text-gray-500">Connect</h4>
              <ul className="space-y-3">
                <li>
                  <a href="mailto:hello@filmcraft.com" className="text-lg font-semibold hover:text-gray-300 transition-colors">
                    Email
                  </a>
                </li>
                <li>
                  <a href="tel:+1234567890" className="text-lg font-semibold hover:text-gray-300 transition-colors">
                    Phone
                  </a>
                </li>
                <li>
                  <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-lg font-semibold hover:text-gray-300 transition-colors">
                    Instagram
                  </a>
                </li>
                <li>
                  <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="text-lg font-semibold hover:text-gray-300 transition-colors">
                    YouTube
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-500">
            © {currentYear} FilmCraft. All rights reserved.
          </p>
          <div className="flex space-x-8">
            <Link to="/privacy" className="text-sm text-gray-500 hover:text-white transition-colors">
              Privacy
            </Link>
            <Link to="/terms" className="text-sm text-gray-500 hover:text-white transition-colors">
              Terms
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterAlt;